export enum TransactionModule {
  Bank = 'BANK',
  CardPersonal = 'CARD_PERSONAL',
  CardLegal = 'CARD_LEGAL',
  Other = 'OTHER',
  None = ' '
}
